module.exports = __webpack_public_path__ + "static/media/canTakeMost.b7e4a1c7.mp3";